import { XMLInterfaceObject } from "@goodgamestudios/core";
import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { ItemsVO } from "./ItemsVO";

export class BoosterVO extends ItemsVO {
    public duration: number = 0;
    public boostChips: number = NaN;
    public boostedChipsMaxTotal: number = NaN;
    public boostedChipsMaxPerWin: number = NaN;
    public boostXP: number = 0;
    public boostedXPMaxTotal: number = 0;
    public boostedXPMaxPerWin: number = 0;

    constructor() {
        CONSTRUCTOR_HACK;
        super();
    }
    public getVisClassName(): string {
        return this.itemCategory + "_" + this.id;
    }
    public fillFromParamXML(wodElement: XMLInterfaceObject): void {
        super.fillFromParamXML(wodElement);
        this.duration = int((wodElement['duration'] || ''));
        this.boostChips = (wodElement['boostChips'] || '');
        this.boostedChipsMaxTotal = (wodElement['boostedChipsMaxTotal'] || '');
        this.boostedChipsMaxPerWin = (wodElement['boostedChipsMaxPerWin'] || '');
        this.boostXP = int((wodElement['boostXP'] || ''));
        this.boostedXPMaxTotal = int((wodElement['boostedXPMaxTotal'] || ''));
        this.boostedXPMaxPerWin = int((wodElement['boostedXPMaxPerWin'] || ''));

        this.priceChips = 0;
        this.colorTableId = -1;
    }
}
classImplementsInterfaces(BoosterVO, "IInventoryVO");
